/* YST Customization: Refresh server-rendered offers after native Focal cart changes. */
(() => {
  'use strict';
  if (customElements.get('yst-product-pairings')) return;
  class YSTProductPairings extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      document.addEventListener('cart:updated', () => this.refresh(), {signal:this.controller.signal});
    }
    disconnectedCallback() { this.controller.abort(); clearTimeout(this.timer); this.request?.abort(); }
    refresh() {
      clearTimeout(this.timer);
      this.timer = setTimeout(async () => {
        this.request?.abort(); this.request = new AbortController();
        const url = new URL(location.href); url.searchParams.set('section_id',this.dataset.sectionId);
        try {
          const response = await fetch(url, {signal:this.request.signal,cache:'no-store'});
          if (!response.ok) return;
          const html = new DOMParser().parseFromString(await response.text(),'text/html');
          const next = html.querySelector('yst-product-pairings');
          if (next && this.isConnected) this.replaceWith(next);
        } catch (_) { /* YST Customization: Preserve the existing block when a refresh fails. */ }
      },250);
    }
  }
  customElements.define('yst-product-pairings',YSTProductPairings);
})();
